import { Comment } from "@nova/schemas"
import { CommentText } from "plugins/Toolbox/MapComments/CommentText"
import { CommentImages } from "plugins/Toolbox/MapComments/CommentImages"
import { CommentReactions } from "./CommentReactions"

export const CommentBody = ({
    comment,
    onPickerOpenChange,
}: {
    comment: Comment<"map-pin" | "map-comment">
    onPickerOpenChange: (open: boolean) => void
}) => (
    <>
        <CommentText
            text={comment.comment}
            className="text-gray-100 text-sm leading-[1.4] break-words"
        />
        {comment.imageKeys.length > 0 && <CommentImages imageKeys={comment.imageKeys} />}
        <CommentReactions comment={comment} onPickerOpenChange={onPickerOpenChange} />
    </>
)
